
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/AuthProvider";

export function useIndividualBookAccess(bookId: number | null) {
  const { session } = useAuth();

  return useQuery({
    queryKey: ['individualBookAccess', session?.user?.id, bookId],
    queryFn: async () => {
      if (!session?.user?.id || !bookId) return false;
      
      const { data, error } = await supabase.rpc('has_individual_book_access', {
        user_id: session.user.id,
        book_id: bookId
      });
      
      if (error) {
        console.error('Error checking individual book access:', error);
        return false;
      }
      
      return data || false;
    },
    enabled: !!session?.user?.id && !!bookId,
    staleTime: 30000
  });
}
